// extracted by mini-css-extract-plugin
export default {"AddButton":"_AddButton--gRs1Y","Popover":"_Popover--LNJ5Q","Header":"_Header--xTaAO","Body":"_Body--YAmrd","Footer":"_Footer--o3eIV"};